import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import {
  Container, makeStyles, Button, CircularProgress, Typography,
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';

import { Auth0Context } from '../../utils/auth0';
import AdminFiltersControl from '../../components/AdminFiltersControl';
import {
  selectProgramData, setFilters, loadProgramData, clearDownload,
} from '../../store/slices/programDataSlice';

export default function UserReportsScreen() {
  const classes = useStyles();
  const { getAccessTokenSilently } = useAuth0() as Auth0Context;

  const dispatch = useDispatch();
  const {
    filters, download, loading, error,
  } = useSelector(selectProgramData);

  useEffect(() => {
    if (download != null) {
      window.location.assign(download.url);
      dispatch(clearDownload());
    }
  }, [download]);

  return (
    <Container className={classes.container}>
      <AdminFiltersControl
        filters={filters}
        onChange={(filters) => dispatch(setFilters(filters))}
        classes={{ container: classes.filtersControl }}
      />
      <div>
        <div className={classes.downloadButtonContainer}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => dispatch(loadProgramData(getAccessTokenSilently))}
            disabled={loading}
          >
            Download Report
          </Button>
          {loading && (
            <CircularProgress
              size={24}
              color="primary"
              className={classes.downloadButtonProgress}
            />
          )}
        </div>
      </div>
      {error != null && (
        <Typography className={classes.error} color="error">
          An error occurred while preparing the report.
        </Typography>
      )}
    </Container>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(3) + 64,
    paddingBottom: theme.spacing(3),
  },
  filtersControl: {
    paddingBottom: theme.spacing(2),
  },
  downloadButtonContainer: {
    position: 'relative',
    display: 'inline-block',
  },
  downloadButtonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  error: {
    marginTop: theme.spacing(2),
  },
}));
